import { render } from "./SavingsRate.vue?vue&type=template&id=60cd2657"
import script from "./SavingsRate.vue?vue&type=script&lang=js"
export * from "./SavingsRate.vue?vue&type=script&lang=js"

import exportComponent from "/home/artur/code/vue/zinzeszinsapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__